import { Component } from 'preact';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[MC] Component error:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div class="mc-system mc-system-error">
          Widget error. Please refresh.
        </div>
      );
    }
    return this.props.children;
  }
}
